import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { isEmpty } from 'lodash';

const AVATAR_COLORS = [
  '#c62828',
  '#ad1457',
  '#6a1b9a',
  '#4527a0',
  '#283593',
  '#1565c0',
  '#4e342e',
  '#00695c',
  '#37474f',
  '#2e7d32',
  '#bf360c',
] as const;

const getAvatarColor = (uid: string): string => {
  console.log('uid', uid);
  // Turn the UID into a number used to pick a color.
  const hash = Array.from(uid).reduce((total, character, index) => total + character.charCodeAt(0) * (index + 1), 0);

  return AVATAR_COLORS[hash % AVATAR_COLORS.length];
};

const getInitials = (name?: string | null, email?: string | null): string => {
  // Treat a name or email containing only whitespace as empty.
  const trimmedName = name?.trim();
  const trimmedEmail = email?.trim();

  if (isEmpty(trimmedName) && isEmpty(trimmedEmail)) {
    return '#';
  }

  try {
    // Names and email usernames use different delimiters.
    const words = !isEmpty(trimmedName)
      ? trimmedName!.split(/\s+/).filter(Boolean)
      : trimmedEmail!.split('@')[0].trim().split(/[._]+/).filter(Boolean);

    // For one word, use its first two letters (for example, "John" becomes "JO").
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }

    // For multiple words, use the first letter of the first and last words.
    return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
  } catch {
    return '##';
  }
};

interface UserAvatarProps {
  uid: string;
  name?: string | null;
  email?: string | null;
}

const UserAvatar = ({ uid, name, email }: UserAvatarProps) => {
  const label = name?.trim() || email?.trim() || uid;

  return (
    <Avatar aria-label={label} style={{ backgroundColor: getAvatarColor(uid) }}>
      {getInitials(name, email)}
    </Avatar>
  );
};

export default UserAvatar;
